// @ts-nocheck
import { Overlay } from '@angular/cdk/overlay';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  forwardRef,
  inject,
} from '@angular/core';
import { ErrorBrokenModalContructor } from '../../../../helpers/_old_helpers/templates/error-service-component/error-modal-constructor';
import { SEND_SERVICE } from '../../../../services/send.service';
import { TASK_SERVICE } from '../../../../services/task.service';
import { USER_SERVICE, UserServiceInterface } from '../../../../services/user.services';
import { BodyFeedbackComponent } from '../../body-feedback/body-feedback.component';
import { DynamicFormService } from '../../dynamic-form/dynamic-form.service';
import { ParallelTaskService } from '../../dynamic-form/sub-modules/parallel-tasks/parallel-task.service';
import { ErrorOverlayClass } from '../../error-overlay/error-overlay.directive';
import { TableCondensedComponent } from '../../table-condensed/table-condensed.component';
import { TableSecondaryComponent } from '../../table-secondary/table-secondary.component';
import { TableComponent } from '../../table/table.component';
import { TableFieldService } from '../table/table-field.service';

@Component({
  selector: 'lbca-table-list',
  templateUrl: './table-list.component.html',
  styleUrl: './table-list.component.scss',
  imports: [
    forwardRef(() => TableComponent),
    forwardRef(() => TableCondensedComponent),
    forwardRef(() => TableSecondaryComponent),
    BodyFeedbackComponent,
  ],
})
export class TableListComponent implements OnInit, AfterViewInit {
  private overlay = inject(Overlay);
  readonly sendService = inject(SEND_SERVICE);
  elementRef = inject(ElementRef);
  tableService = inject(TableFieldService);
  private parallelTaskService = inject(ParallelTaskService);
  readonly taskService = inject(TASK_SERVICE);
  private dynamicFormService = inject(DynamicFormService);
  readonly userService = inject<UserServiceInterface>(USER_SERVICE);

  public userId!: string;
  public dataTable: any[] = [];
  private _value: any;
  public fieldValues!: any;
  public isDisabled = false;
  public isLoaded = false;
  public hasError = false;

  public fixedPageLimit: any = null;
  private actualPage = 1;
  private lastEvaluationKeys: any = { 1: undefined };
  private nextLastEvaluatedKey: any = undefined;
  private errorPopup: ErrorOverlayClass;
  public lineCickable = false;
  public table: any = { body: [] };

  public editParallel: boolean = false;
  public tableType: 'table-default' | 'table-condensed' | 'table-secondary' = 'table-default';
  public saveKey!: string;

  public dataAttr: any = {};
  @Input('dataAttr') set data(data) {
    this.dataAttr = data;
  }

  @Input()
  set setLineClickable(value: any) {
    this.lineCickable = value;
  }

  @Input('editParallel')
  set setEditParallel(value: any) {
    this.editParallel = value;
  }

  loadType = 'details';

  @Input()
  set field(data: any) {
    this.fieldValues = data;
    if (data.historic) this.loadType = 'history';
    if (data.loadProcessId) this.loadType = 'loadProcessId';
    if (data.tableDisplay) this.tableType = data.tableDisplay || 'table-default';
    if (data.saveKey) this.saveKey = data.saveKey;
  }

  @Input() set disabled(disabled) {
    this.isDisabled = disabled;
  }

  @Input('error')
  set err(error) {
    if (error && error.length > 0) {
      this.hasError = true;
      this.errorPopup.setErrors(error);
    } else {
      this.hasError = false;
      this.errorPopup.setErrors([]);
    }
  }

  @Input()
  set body(val: any) {
    if (val) this.table.body = val;
  }

  @Input()
  set value(val: any) {
    if (val) {
      this._value = val;
      this.table.body = val;
    }
  }

  @Input() allValues;

  public cardInfo!: any;
  @Input()
  set cardData(data: any) {
    this.cardInfo = data;
  }
  @Output() setControlCloud = new EventEmitter<string>();
  @Output() clickEventEmmit = new EventEmitter<any>();

  errorComponent;

  constructor() {
    const overlay = this.overlay;

    this.errorComponent = new ErrorBrokenModalContructor(overlay);
    this.errorPopup = new ErrorOverlayClass(overlay);
  }

  ngAfterViewInit(): void {
    this.errorPopup.setPosition(
      this.elementRef,
      [
        {
          originX: 'start',
          originY: 'top',
          overlayX: 'start',
          overlayY: 'bottom',
        },
      ],
      0,
      0,
      'bottom',
      'start'
    );

    setTimeout(() => {
      if (this.loadType === 'history') this.getHistory();
      if (this.loadType === 'loadProcessId') this.loadProcessId();
      if (this.loadType === 'details') this.getDetails();
      if (!this.loadType) setTimeout(() => (this.isLoaded = true), 2000);
    }, 1000);
  }

  ngOnInit(): void {
    const cols: any[] = [];
    let details = [];

    this.userId = this.userService.getUserInfo()?.userId ?? ('' as any);

    if (this.fieldValues.configuration.primary)
      this.fieldValues.configuration.primary.forEach((element, index) => {
        const obj = {
          name: element.entityKey,
          label: element.label
            ? element.label
            : element.labelDate && element.labelTime
            ? element.labelDate + ' / ' + element.labelTime
            : null,
          type: 'data',
          cssHeader: 'text-left',
          orderDefault: index === 1 ? true : false,
          order: false,
          col: element.size,
          field: element,
        };

        cols.push(obj);
      });

    if (this.fieldValues.configuration.secondary)
      details = this.fieldValues.configuration.secondary;

    this.table = {
      ...this.table,
      columns: cols,
      details,
      config: {
        ...(this.fieldValues?.configuration?.config ?? {}),
        highlight: (lane) => {
          return true;
        },
      },
    };
  }

  private getHistory() {
    const context = this.fieldValues.historic.context;
    const params = {
      context,
      processId: this.dataAttr.processNumber,
    };

    this.parallelTaskService.getParallelHistory(params).subscribe((resp) => {
      if (resp.pending) {
        setTimeout(() => {
          this.getHistory(), 2000;
        });
      } else {
        const checkRet = Array.isArray(resp) ? true : false;
        this.table.body = checkRet ? resp : [];
        this.isDisabled = true;
        this.isLoaded = true;
      }
    });
  }

  public clickEvent(event) {
    this.clickEventEmmit.emit(event);
  }

  public async getDetails() {
    const idsList = this._value;
    if (!this.fieldValues.auxEntity || !idsList) return;
    const { entityRecoverUrl, tableName } = this.fieldValues.auxEntity;
    const ids = JSON.stringify(idsList);
    const params = {
      ids,
      tableName,
      taskId: this.cardInfo.id,
    };

    await new Promise((resolve, reject) => {
      this.tableService.getDinamicUrl(entityRecoverUrl, params).subscribe((resp: any) => {
        this.table.body = resp;
        resolve(resp);
      });
    });

    this.isLoaded = true;
  }

  public async loadProcessId(extraParams = {}) {
    /**No caso foi colocado mais uma validação caso o processId ainda esteja null*/
    const idsList = this.cardInfo.processId || null;
    if (!this.fieldValues.auxEntity) return;
    const { entityRecoverUrl, entityParameters } = this.fieldValues.auxEntity;
    const params = {
      processId: idsList || this.dataAttr.processNumber,
      userId: this.userId,
      taskId: this.cardInfo.id,
      context: this.fieldValues.context || 'undefined',
      tableName: this.fieldValues?.auxEntity?.tableName,
      ...extraParams,
    };

    if (Array.isArray(entityParameters) && entityParameters.length > 0) {
      for (const parameters of entityParameters) {
        const { parameterKey, isMetadata, formKey, value, extractFromAllValues } = parameters;
        if (value) {
          params[parameterKey] = value;
        } else if (extractFromAllValues) {
          params[parameterKey] = this.allValues[formKey];
        } else {
          params[parameterKey] = isMetadata
            ? this.dynamicFormService.formControlStructure?.formMetadata?.[formKey]
            : this.dynamicFormService.formControlStructure?.fieldControl?.[formKey];
        }
      }
    }

    await new Promise((resolve, reject) => {
      this.tableService.getDinamicUrl(entityRecoverUrl, params).subscribe((resp: any) => {
        if (resp && Array.isArray(resp)) {
          this.table.body = this.table.body?.map((element) => {
            const item = resp.find((v) => v.id === (element?.id ?? element));

            if (item) {
              if (typeof element === 'string') {
                return { id: element, ...item };
              }
              return { ...element, ...item };
            } else {
              return element;
            }
          });

          const body = resp
            ? resp.filter((row) => !this.table.body?.map((v) => v.id).includes(row.id))
            : [];

          this.table.body = this.table.body?.concat(body);
          resolve(resp);
        } else if (params['limit']) {
          if (resp?.Items?.length > 0) {
            this.table.body = [...resp.Items];
            if (this.table.config.pagination) {
              const pagination = { ...this.table.config.pagination };
              if (!this.fixedPageLimit) {
                pagination['totalPagesValue'] = resp.LastEvaluatedKey
                  ? this.actualPage + 1
                  : this.actualPage;
              }
              this.table.config = { ...this.table.config, pagination };
              this.lastEvaluationKeys[this.actualPage + 1] = this.nextLastEvaluatedKey =
                resp.LastEvaluatedKey;
            }
          } else if (this.table.config.pagination && this.actualPage > 1) {
            this.fixedPageLimit = this.actualPage - 1;
            const pagination = { ...this.table.config.pagination };
            pagination['totalPagesValue'] = this.fixedPageLimit;
            this.table.config = { ...this.table.config, pagination };
          }
        }
        resolve(true);
      });
    });

    this.isLoaded = true;
  }

  onPageChange(event) {
    let lastEvaluatedKey;
    if (event > this.actualPage) {
      lastEvaluatedKey = this.nextLastEvaluatedKey;
    } else if (event < this.actualPage) {
      lastEvaluatedKey = this.lastEvaluationKeys[event];
    }
    this.actualPage = event;
    // setTimeout(() => {
    this.isLoaded = false;
    // },150)
    this.loadProcessId(
      lastEvaluatedKey
        ? {
            lastEvaluatedKey: JSON.stringify(lastEvaluatedKey),
          }
        : undefined
    );
  }

  orderTable($event) {}

  public valueList: any[] = [];

  changeVal($event) {
    const lane = $event.lane;
    const value = $event.value;
    const entityKey = $event.entityKey;
    const editable = $event.editable;
    lane[entityKey] = value;

    const newBody = this.table.body.map((row) => {
      if (row.id === lane.id) {
        return lane;
      } else {
        return row;
      }
    });

    if (editable && this.saveKey) {
      const field = { id: lane.id, [entityKey]: value };
      if (this.valueList.length === 0) {
        this.valueList.push(field);
      } else {
        const indexObjectExists = this.valueList.findIndex((obj) => field.id === obj.id);

        if (indexObjectExists !== -1) {
          this.valueList[indexObjectExists] = { ...this.valueList[indexObjectExists], ...field };
        } else {
          this.valueList.push(field);
        }
      }
      this.dynamicFormService.setTimeOutToSaveData(this.saveKey, this.valueList);
    }
    //caso tenha este valor no template, faz o draft no onchange
    if (this.fieldValues?.auxEntity?.entitySaveDraftUrl && editable) {
      if (this.cardInfo.status !== 'complete') {
        const taskId = this.cardInfo.id ?? this.dynamicFormService.taskId;
        const userId = this.userId;
        const params = { taskId, userId };

        this.taskService.getDraft(params).subscribe((resp: any) => {
          if (resp && resp.userId === userId && resp.taskId === taskId) {
            const body = { [entityKey]: value };
            const path = this.fieldValues?.auxEntity?.entitySaveDraftUrl;
            const params = {
              id: lane.id,
              userId: this.userId,
              taskId: this.dataAttr.bpmIdCard,
              tableName: this.fieldValues?.auxEntity?.tableName,
            };
            this.setControlCloud.emit('saving');
            const observer = {
              next: () => this.setControlCloud.emit('saved'),
              error: () => this.setControlCloud.emit('error'),
            };
            this.sendService.put(path, body, { params }).subscribe(observer);
          }
        });
      }
    }
  }

  public markedItems: any[] = [];

  public checkboxEntityKey = 'setAlert';

  sendMarkedItems(event) {
    const checkboxEntityKey = this.checkboxEntityKey;
    const fieldValue =
      this.dynamicFormService.formControlStructure?.fieldControl?.[this.fieldValues.entityKey]
        ?.value;
    if (Array.isArray(fieldValue)) {
      if (fieldValue?.length > 0) {
        if (fieldValue.some((item: any) => item.id === event.id)) {
          switch (event?.operation) {
            case 'add':
              this.markedItems = fieldValue.map((item: any) => {
                if (item.id === event.id) {
                  return {
                    ...item,
                    [checkboxEntityKey]: true,
                  };
                }
                return item;
              });
              break;
            case 'remove':
              this.markedItems =
                Array.isArray(fieldValue) && fieldValue?.length > 0
                  ? fieldValue
                      .map((item: any) => {
                        if (item.id === event.id) {
                          delete (item as any)[checkboxEntityKey];
                          if (Object.keys(item).length < 2) {
                            return undefined;
                          }
                          return {
                            ...item,
                          };
                        }
                        return item;
                      })
                      .filter((item: any) => item !== undefined)
                  : (fieldValue as any[]);
          }
        } else {
          switch (event?.operation) {
            case 'add':
              fieldValue.push({
                [checkboxEntityKey]: true,
                id: event.id,
              });
              this.markedItems = [...fieldValue];
              break;
            case 'remove':
              console.log('Item does not exist in array');
          }
        }
      } else {
        switch (event?.operation) {
          case 'add':
            fieldValue.push({
              [checkboxEntityKey]: true,
              id: event.id,
            });
            this.markedItems = [...fieldValue];
            break;
          case 'remove':
            console.log('Array is empty');
        }
      }
    } else {
      switch (event?.operation) {
        case 'add':
          this.markedItems.push({
            [checkboxEntityKey]: true,
            id: event.id,
          });

          break;
        case 'remove':
          console.log('Array is empty');
      }
    }
    this.dynamicFormService.changeInterceptor.emit({
      changeSource: 'userInput',
      id: this.fieldValues.entityKey,
      value: [...this.markedItems],
    });
  }
}
